// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.SoDecJZJekD9VXGoBRAv:hover, .SoDecJZJekD9VXGoBRAv[data-hovered] {
    font-weight: 500;
    background-color: #1A1B1E;
}

.rPZZLCjsjLz1jbmG24Ac:hover, .HUkwQ3eUCSKsxB3dGtu9[data-hovered] {
    font-weight: 500;
    background-color: #FFF;
}

.wkptMKovF3DMMPcSLksQ:hover { opacity: 0.7 }

.bppvzWg1MyGcDqexjWBn:hover { border-color:#1C7ED6 !important; }


.BPpNYG3BBPhMoH_kEKNn:hover {
    border: 1px solid #ced4da;
}

.uNd_P_xBfp3Hi9UeTpeL:hover { font-weight: 700; }


.alsXWypGk7Ae2WTv858X option { font-size: 18px }

.RcAQV6LOJGDWLP0YUS2M {
    text-decoration: none;
}

.RcAQV6LOJGDWLP0YUS2M:hover {
    text-decoration: underline;
    cursor: pointer;
}

.yDiAPFplaQm8y2M_5FCe svg {
    width: 50px !important;
    height: 50px !important;
}

.zSMn5DdldextAhXW_hLv {

}

.KmH51Y5MC2WaFtDRtQMG:hover {
    background-color: #dee2e6 !important;
    cursor: pointer;
}

.KmH51Y5MC2WaFtDRtQMG:active {
    background-color: #c8cbcf !important;
}

.yrNiplQyCfFxlu4vlczm:hover {
    background-color: #e9e9e9 !important;
    cursor: pointer;
    outline: solid 2px dodgerblue;
}

.yrNiplQyCfFxlu4vlczm:active {
    background-color: #e0e0e0 !important;
}

.zSMn5DdldextAhXW_hLv .qNc4NfFSyuX7ta1JyBB_ { display: flex; }
.zSMn5DdldextAhXW_hLv:hover .qNc4NfFSyuX7ta1JyBB_ { display: none; }

.zSMn5DdldextAhXW_hLv .O6Zf2Ow90NyjSn_qeqx0 { display: none; }
.zSMn5DdldextAhXW_hLv:hover .O6Zf2Ow90NyjSn_qeqx0 { display: flex; }

.zT1NOl7KhBasj0r7od2W {
}

.zT1NOl7KhBasj0r7od2W .N0KbkwCUcryXpM11AuAS { display: none; }
.zT1NOl7KhBasj0r7od2W:hover .N0KbkwCUcryXpM11AuAS { display: flex; }

.Q5DliQI8BTG_rkF66nzT {
    max-width: 250px;
    width: 250px;
    box-sizing: border-box;
    border: 1px solid #dee2e6;
    border-left: none;
    border-top: none;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
    background-color: rgb(245, 245, 245);
    position: sticky;
    top: 0;
    overflow: hidden;
}

.GfS3NWY3PKAkBjdEnVDs, .Hii_FjAti_hqylSBWMEe {
    height: 37px;
    max-width: 250px;
    width: 250px;
    box-sizing: border-box;
    border: 1px solid #dee2e6;
    border-left: none;
    border-top: none;
    align-items: center;
    justify-content: space-between;
    background-color: #FFF;
    overflow: hidden;
    position: relative;
}

.zJ49isdNlYmChBzEMIhU {
    background-color: #f5f5f5;
}

.Hii_FjAti_hqylSBWMEe {
    left: 0;
    position: sticky;
    z-index: 1000;
}

.jIyW96HZskCRTI5ywi2g {
    flex: 1;
    height: 100%;
}

.jIyW96HZskCRTI5ywi2g input {
    background-color: unset;
    color: #000;
    opacity: 1;
}

.jIyW96HZskCRTI5ywi2g button {
    background-color: unset;
    color: #000;
    opacity: 1;
}

.LpaPfGiDaCy68OydqMYp {
    align-items: center;
    justify-content: space-between;
    padding: 8;
    overflow: hidden;
    z-index: 999
}


.mRtwTR7uMDPLAWuqIiY_ {
    transform: translateY(-100%); /* Hide the header */
}

.qDlDxcFelaN2ieWMzAkH {
    transform: translateY(0); /* Show the header */
}
`, "",{"version":3,"sources":["webpack://./src/styles/nestedStyles.module.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,8BAA+B,aAAa;;AAE5C,8BAA2B,+BAA+B,EAAE;;;AAG5D;IACI,yBAAyB;AAC7B;;AAEA,8BAAyB,gBAAgB,EAAE;;;AAG3C,+BAAuB,gBAAgB;;AAEvC;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;AAEA;;AAEA;IACI,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,8CAA4B,aAAa,EAAE;AAC3C,oDAAkC,aAAa,EAAE;;AAEjD,8CAA4B,aAAa,EAAE;AAC3C,oDAAkC,aAAa,EAAE;;AAEjD;AACA;;AAEA,8CAAiC,aAAa,EAAE;AAChD,oDAAuC,aAAa,EAAE;;AAEtD;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,oCAAoC;IACpC,gBAAgB;IAChB,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;IAChB;AACJ;;;AAGA;IACI,4BAA4B,EAAE,oBAAoB;AACtD;;AAEA;IACI,wBAAwB,EAAE,oBAAoB;AAClD","sourcesContent":["\n.hover-button-dark-mode:hover, .hover-button-dark-mode[data-hovered] {\n    font-weight: 500;\n    background-color: #1A1B1E;\n}\n\n.hover-button-dark-light:hover, .hover-button-light-mode[data-hovered] {\n    font-weight: 500;\n    background-color: #FFF;\n}\n\n.hover-clickable-image:hover { opacity: 0.7 }\n\n.hover-action-blue:hover { border-color:#1C7ED6 !important; }\n\n\n.hover-text-ListItem:hover {\n    border: 1px solid #ced4da;\n}\n\n.hover-text-bold:hover { font-weight: 700; }\n\n\n.selectNative option { font-size: 18px }\n\n.hover-text-action {\n    text-decoration: none;\n}\n\n.hover-text-action:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.mantine-Carousel-control-large svg {\n    width: 50px !important;\n    height: 50px !important;\n}\n\n.hover-button {\n\n}\n\n.hover-action-card:hover {\n    background-color: #dee2e6 !important;\n    cursor: pointer;\n}\n\n.hover-action-card:active {\n    background-color: #c8cbcf !important;\n}\n\n.hover-action-card-outlined:hover {\n    background-color: #e9e9e9 !important;\n    cursor: pointer;\n    outline: solid 2px dodgerblue;\n}\n\n.hover-action-card-outlined:active {\n    background-color: #e0e0e0 !important;\n}\n\n.hover-button .hover-hide { display: flex; }\n.hover-button:hover .hover-hide { display: none; }\n\n.hover-button .hover-show { display: none; }\n.hover-button:hover .hover-show { display: flex; }\n\n.hover-image {\n}\n\n.hover-image .hover-image-show { display: none; }\n.hover-image:hover .hover-image-show { display: flex; }\n\n.bulk-edit-header {\n    max-width: 250px;\n    width: 250px;\n    box-sizing: border-box;\n    border: 1px solid #dee2e6;\n    border-left: none;\n    border-top: none;\n    align-items: center;\n    justify-content: space-between;\n    padding: 5px 10px;\n    background-color: rgb(245, 245, 245);\n    position: sticky;\n    top: 0;\n    overflow: hidden;\n}\n\n.bulk-edit-column, .bulk-edit-column-sticky {\n    height: 37px;\n    max-width: 250px;\n    width: 250px;\n    box-sizing: border-box;\n    border: 1px solid #dee2e6;\n    border-left: none;\n    border-top: none;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #FFF;\n    overflow: hidden;\n    position: relative;\n}\n\n.bulk-edit-column-disabled {\n    background-color: #f5f5f5;\n}\n\n.bulk-edit-column-sticky {\n    left: 0;\n    position: sticky;\n    z-index: 1000;\n}\n\n.bulk-edit-column-input {\n    flex: 1;\n    height: 100%;\n}\n\n.bulk-edit-column-input input {\n    background-color: unset;\n    color: #000;\n    opacity: 1;\n}\n\n.bulk-edit-column-input button {\n    background-color: unset;\n    color: #000;\n    opacity: 1;\n}\n\n.bulk-edit-column-text {\n    align-items: center;\n    justify-content: space-between;\n    padding: 8;\n    overflow: hidden;\n    z-index: 999\n}\n\n\n.transform-hidden {\n    transform: translateY(-100%); /* Hide the header */\n}\n\n.transform-visible {\n    transform: translateY(0); /* Show the header */\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `SoDecJZJekD9VXGoBRAv`;
export { _1 as "hover-button-dark-mode" };
var _2 = `rPZZLCjsjLz1jbmG24Ac`;
export { _2 as "hover-button-dark-light" };
var _3 = `HUkwQ3eUCSKsxB3dGtu9`;
export { _3 as "hover-button-light-mode" };
var _4 = `wkptMKovF3DMMPcSLksQ`;
export { _4 as "hover-clickable-image" };
var _5 = `bppvzWg1MyGcDqexjWBn`;
export { _5 as "hover-action-blue" };
var _6 = `BPpNYG3BBPhMoH_kEKNn`;
export { _6 as "hover-text-ListItem" };
var _7 = `uNd_P_xBfp3Hi9UeTpeL`;
export { _7 as "hover-text-bold" };
export var selectNative = `alsXWypGk7Ae2WTv858X`;
var _8 = `RcAQV6LOJGDWLP0YUS2M`;
export { _8 as "hover-text-action" };
var _9 = `yDiAPFplaQm8y2M_5FCe`;
export { _9 as "mantine-Carousel-control-large" };
var _a = `zSMn5DdldextAhXW_hLv`;
export { _a as "hover-button" };
var _b = `KmH51Y5MC2WaFtDRtQMG`;
export { _b as "hover-action-card" };
var _c = `yrNiplQyCfFxlu4vlczm`;
export { _c as "hover-action-card-outlined" };
var _d = `qNc4NfFSyuX7ta1JyBB_`;
export { _d as "hover-hide" };
var _e = `O6Zf2Ow90NyjSn_qeqx0`;
export { _e as "hover-show" };
var _f = `zT1NOl7KhBasj0r7od2W`;
export { _f as "hover-image" };
var _10 = `N0KbkwCUcryXpM11AuAS`;
export { _10 as "hover-image-show" };
var _11 = `Q5DliQI8BTG_rkF66nzT`;
export { _11 as "bulk-edit-header" };
var _12 = `GfS3NWY3PKAkBjdEnVDs`;
export { _12 as "bulk-edit-column" };
var _13 = `Hii_FjAti_hqylSBWMEe`;
export { _13 as "bulk-edit-column-sticky" };
var _14 = `zJ49isdNlYmChBzEMIhU`;
export { _14 as "bulk-edit-column-disabled" };
var _15 = `jIyW96HZskCRTI5ywi2g`;
export { _15 as "bulk-edit-column-input" };
var _16 = `LpaPfGiDaCy68OydqMYp`;
export { _16 as "bulk-edit-column-text" };
var _17 = `mRtwTR7uMDPLAWuqIiY_`;
export { _17 as "transform-hidden" };
var _18 = `qDlDxcFelaN2ieWMzAkH`;
export { _18 as "transform-visible" };
export default ___CSS_LOADER_EXPORT___;
